import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import AccountCircle from "@material-ui/icons/AccountCircle";
import AppleIcon from "@material-ui/icons/Apple";
import Input from "@material-ui/icons/Input";
import CircularProgress from "@material-ui/core/CircularProgress";
import FacebookIcon from "@material-ui/icons/Facebook";
import {
  hideMessage,
  userFacebookSignIn,
  userGithubSignIn,
  userGoogleSignIn,
  userSignIn,
  userTwitterSignIn,
  userSignInSocial,
} from "actions/Auth";
import { Helmet } from "react-helmet";
import { push, replace } from "connected-react-router";
import { gameInfo, loginGame, getGameFailed } from "actions/Game";
import { setNavigateParams } from "actions/Navigate";
import { getLoggedGamesFromStorage } from "util/Common";

class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      appID: "",
      loginSelect: "",
    };
  }

  componentDidUpdate() {
    const appIds = getLoggedGamesFromStorage();

    const {
      push,
      hideMessage,
      authUser,
      gameID,
      error,
      showMessage,
      redirectData,
    } = this.props;

    if (showMessage) {
      setTimeout(() => {
        hideMessage();
      }, 100);
    }

    if (authUser !== null && appIds.indexOf(gameID) !== -1) {
      push("/home");
    }

    if (error) {
      push("/home");
    }

    if (
      this.state.loginSelect &&
      this.state.loginSelect === "zalo" &&
      this.props.loginMethods.length !== 0 &&
      this.props.loginMethods.includes(this.state.loginSelect)
    ) {
      this.handleRedirect({
        loginTypeName: "zalo",
        gameID: this.props.gameData[0].appID,
        mapID: this.props.gameData[0].loginConfig.mapID,
        countryID: this.props.gameData[0].countryID,
      });
    }

    if (redirectData) {
      window.location.href = redirectData;
    }
  }

  componentDidMount() {
    const {
      query,
      gameID,
      setNavigateParams,
      push,
      gameInfo,
      search,
    } = this.props;

    const { gameID: paraGameID, loginType } = query;
    const gId = paraGameID || gameID;
    if (query && query.error === "-405") {
      NotificationManager.error("Đăng nhập không hợp lệ.")
    }  
    if (search) {
      //replace(pathname);
    }

    if (gId) {
      setNavigateParams({ gameID: gId });
      gameInfo({
        gameID: gId,
      });

      if (loginType) {
        this.setState({
          loginSelect: loginType,
        });
      }
    } else {
      push("/");
    }
  }

  componentWillUnmount() {
    const { getGameFailed, hideMessage } = this.props;
    hideMessage();
    getGameFailed(null);
  }

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleRedirect = (payload) => {
    const { loginTypeName, gameID, mapID, countryID } = payload;

    if (loginTypeName === "zingid") {
      window.open("https://id.zing.vn/");
    } else {
      window.location = `${process.env.REACT_APP_LOGIN_ENDPOINT}/oauth/${loginTypeName}?gameID=${gameID}&mapID=${mapID}&lang=${countryID}&ver=v2`;
    }
  };

  render() {
    const { email, password } = this.state;
    const {
      showMessage,
      loader,
      alertMessage,
      gameData,
      loginMethods,
    } = this.props;
    const isEmailEnable = loginMethods &&
    loginMethods.length &&
    loginMethods.indexOf("email") !== -1;
    const isSocialEnable = loginMethods &&
      loginMethods.length &&
      (loginMethods.indexOf("zalo") !== -1 ||
        loginMethods.indexOf("facebook") !== -1 ||
        loginMethods.indexOf("zing") !== -1);
    return (
      <div className="login">
        {gameData && gameData.length ? (
          <div
            className="login-wrapper"
            style={{ backgroundImage: `url(${gameData[0].images.loginBaner})` }}
          >
            <Helmet>
              <title>
                {gameData && gameData.length
                  ? gameData[0].shopfrontName
                  : "Trang thông tin User"}
              </title>
            </Helmet>
            <Link to="/home" style={{ margin: "40px auto" }}>
              <img
                src={process.env.PUBLIC_URL + "/Zing_official_logo.png"}
                alt=""
                style={{ maxHeight: 55, maxWidth: "100%" }}
              />
            </Link>
            <div className="block-login">
              <div className="logo-game">
                <img src={gameData[0].images.logo} alt="" />
              </div>

              {isEmailEnable ? (
                <div className="login-form">
                  <b>Tài khoản chơi ngay (Email)</b>
                  <input
                    type="email"
                    name="name"
                    placeholder="Email bảo vệ tài khoản"
                    value={email}
                    onChange={this.handleChange("email")}
                    required
                  />
                  <input
                    type="password"
                    name="password"
                    placeholder="Mật khẩu"
                    value={password}
                    onChange={this.handleChange("password")}
                    required
                  />
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    startIcon={<Input />}
                    onClick={() => {
                      this.props.userSignIn({
                        email,
                        password,
                        gameID: gameData[0].appID,
                        mapID: gameData[0].loginConfig["mapID"],
                        appID: gameData[0].appID,
                        countryID: gameData[0].countryID,
                      });
                    }}
                  >
                    đăng nhập
                  </Button>
                </div>
              ) : (
                ""
              )}
              {isSocialEnable?(
                <div className="login-method">
                  <b>{isEmailEnable ? "Hoặc đăng nhập bằng" : "Đăng nhập bằng"}</b>
                  {loginMethods &&
                  loginMethods.length &&
                  loginMethods.indexOf("zalo") !== -1 ? (
                    <Button
                      variant="contained"
                      size="large"
                      color="primary"
                      startIcon={<AccountCircle />}
                      style={{ background: "#348aca" }}
                      onClick={() => {
                        this.handleRedirect({
                          loginTypeName: "zalo",
                          gameID: gameData[0].appID,
                          mapID: gameData[0].loginConfig.mapID,
                          countryID: gameData[0].countryID,
                        });
                      }}
                    >
                      Zalo
                    </Button>
                  ) : (
                    ""
                  )}
                  {loginMethods &&
                  loginMethods.length &&
                  loginMethods.indexOf("facebook") !== -1 ? (
                    <Button
                      variant="contained"
                      size="large"
                      color="primary"
                      startIcon={<FacebookIcon color="inherit" />}
                      style={{ background: "#3b5998" }}
                      onClick={() => {
                        this.handleRedirect({
                          loginTypeName: "facebook",
                          gameID: gameData[0].appID,
                          mapID: gameData[0].loginConfig.mapID,
                          countryID: gameData[0].countryID,
                        });
                      }}
                    >
                      Facebook
                    </Button>
                  ) : (
                    ""
                  )}
                  {loginMethods &&
                  loginMethods.length &&
                  loginMethods.indexOf("google") !== -1 ? (
                    <Button
                      variant="contained"
                      size="large"
                      color="primary"
                      startIcon={<AccountCircle />}
                      style={{ background: "#DB4437" }}
                      onClick={() => {
                        this.handleRedirect({
                          loginTypeName: "google",
                          gameID: gameData[0].appID,
                          mapID: gameData[0].loginConfig.mapID,
                          countryID: gameData[0].countryID,
                        });
                      }}
                    >
                      Google
                    </Button>
                  ) : (
                    ""
                  )}
                  {loginMethods &&
                  loginMethods.length &&
                  loginMethods.indexOf("zing") !== -1 ? (
                    <Button
                      variant="contained"
                      size="large"
                      color="primary"
                      startIcon={<AccountCircle />}
                      style={{ background: "#189BD2" }}
                      onClick={() => {
                        this.handleRedirect({
                          loginTypeName: "zingid",
                        });
                      }}
                    >
                      Zing ID
                    </Button>
                  ) : (
                    ""
                  )}
                  {loginMethods &&
                  loginMethods.length &&
                  loginMethods.indexOf("apple") !== -1 ? (
                    <Button
                      variant="contained"
                      size="large"
                      color="primary"
                      startIcon={<AppleIcon color="inherit" />}
                      style={{ background: "#050708" }}
                      onClick={() => {
                        this.handleRedirect({
                          loginTypeName: "apple",
                          gameID: gameData[0].appID,
                          mapID: gameData[0].loginConfig.mapID,
                          countryID: gameData[0].countryID,
                        });
                      }}
                    >
                      Apple ID
                    </Button>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          ""
        )}
        {loader && (
          <div className="loader-view">
            <CircularProgress />
          </div>
        )}
        {showMessage && NotificationManager.error(alertMessage)}
        <NotificationContainer />
      </div>
    );
  }
}

const mapStateToProps = ({ auth, game, navigateParams, router }) => {
  const {
    location: { pathname, query, search },
  } = router;
  const {
    loader,
    alertMessage,
    showMessage,
    authUser,
    appIds,
    redirectData,
  } = auth;

  const { gameData, loginMethods, error } = game;
  const { gameID } = navigateParams;
  const loginMethosFiltered = filterArrayByLoginMethods(query["loginMethods"], loginMethods)
  
  return {
    loader,
    alertMessage,
    showMessage,
    authUser,
    gameData,
    loginMethods: loginMethosFiltered,
    appIds,
    gameID,
    error,
    pathname,
    query,
    search,
    redirectData,
  };
};

function filterArrayByLoginMethods(loginMethods, arrayToFilter) {
  if (!loginMethods) {
      return arrayToFilter;
  }
  if (!arrayToFilter) {
      console.log("arrayToFilter là null hoặc không xác định.");
      return [];
  }
  const methodsArray = loginMethods.split(',');
  const filteredArray = arrayToFilter.filter(item => methodsArray.includes(item));
  return filteredArray;
}




export default connect(mapStateToProps, {
  userSignIn,
  hideMessage,
  userFacebookSignIn,
  userGoogleSignIn,
  userGithubSignIn,
  userTwitterSignIn,
  loginGame,
  userSignInSocial,
  push,
  getGameFailed,
  gameInfo,
  replace,
  setNavigateParams,
})(Login);
